export const getAuthHeaders = (isFormData = false, restaurantId) => {
  // Auth is carried by the httpOnly session cookie (sent automatically by
  // the shared axios client), not a header — nothing here reads a token.
  const headers = {};

  if (isFormData) {
    // Let the browser set multipart boundaries. A raw
    // "Content-Type: multipart/form-data" header makes multer miss the files.
  } else {
    headers["Content-Type"] = "application/json";
  }

  if (restaurantId) {
    headers["restaurant-id"] = restaurantId;
  }

  return { headers };
};
